<template>
    <div>
      <label :for="id" v-if="plkparams.title">{{$t(plkparams.title)}}</label>
      <input :id="id" v-model="model" :type="plkparams.type || 'text'" :disabled="plkparams.disabled" :pattern="plkparams.pattern" :required="plkparams.required" class="u-full-width" :placeholder="$t(plkparams.placeholder)" :minlength="plkparams.minlength" :maxlength="plkparams.maxlength"/>
    </div>
</template>

<script>
import i18n from './i18n'
import fields from '@/mixins/fields'
export default {
  name: 'entry',
  mixins: [
    fields
  ],
  methods: {
    onInitComponent () {
      this.$servicesPLK.translation.init(i18n, { overwrite: false })
      this.setModel()
    }
  }
}
</script>

<style scoped lang="scss">
</style>
